import { usePostMutation } from "@/api/swr/useMutation";
import { simpleAssessmentCreateSchema } from "@/schema/console/simple-assessments/SimpleAssessmentDetail";
import { z } from "zod";

export function useCreateSimpleAssessment() {
  return usePostMutation(
    simpleAssessmentCreateSchema,
    z.null(),
    "/console/assessment_papers",
  );
}
